import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "logout",
  "use": "logout-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"logout\"><title>logout</title><g id=\"logout_logout\"><path d=\"M16.3535,7.6465a.5.5,0,0,0-.707.707L17.293,10H7.4792a.5.5,0,0,0,0,1H17.293l-1.6465,1.6465a.5.5,0,1,0,.707.707L19.207,10.5Z\" /><path d=\"M13.2061,12.51a.5009.5009,0,0,0-.6622.2495,5.5,5.5,0,1,1,0-4.52.5.5,0,0,0,.9122-.4121,6.5,6.5,0,1,0,0,5.3438A.5.5,0,0,0,13.2061,12.51Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/logout.svg
// module id = fmgo
// module chunks = 4